import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

/**
 * Fetch audit logs for an entity
 * @param {Object} params
 * @param {number} params.entityPrimaryId - Entity primary ID
 * @param {number} params.pageNo - Page number (default: 1)
 * @param {number} params.pageSize - Page size (default: 10)
 * @returns {Promise<{success: boolean, data?: Array, totalCount?: number, message?: string, error?: any}>}
 */
export const fetchAuditLogsAction = async ({
  entityPrimaryId,
  pageNo = 1,
  pageSize = 10,
}) => {
  try {
    if (!entityPrimaryId) {
      return {
        success: false,
        message: "Entity Primary ID is required",
        data: [],
        totalCount: 0,
      };
    }

    const response = await apiClient.post(ATP_API_URL.GET_AUDIT_LOGS, {
      entityPrimaryId,
      pageNo,
      pageSize,
    });

    console.log("[AuditLogs] API response:", response?.data);

    if (response?.status === 200 && response.data) {
      const { success, data, totalCount } = response.data;

      if (success) {
        return {
          success: true,
          data: data || [],
          totalCount: totalCount || 0,
        };
      }
    }

    return {
      success: false,
      message: "Failed to fetch audit logs",
      data: [],
      totalCount: 0,
    };
  } catch (error) {
    console.error("[AuditLogs] error:", error);
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch audit logs",
      error,
      data: [],
      totalCount: 0,
    };
  }
};
